import { Link } from "react-router-dom";
import { categories } from "@/mocks/content";
import { getContentsByType } from "@/lib/content";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            按心情选内容
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            想笑、想放松、想被治愈？三个入口，总有一个适合此刻的你。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.type}
            to={`/category/${cat.type}`}
            className="group relative rounded-lg overflow-hidden h-56 md:h-64"
          >
            <img
              src={cat.cover}
              alt={cat.name}
              title={`${cat.name} - 羞羞网站`}
              className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/35 to-transparent" />
            <div className="relative z-10 h-full p-5 md:p-6 flex flex-col justify-end">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center mb-3">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <h3 className="font-heading font-bold text-xl text-background-50">{cat.name}</h3>
              <p className="text-background-50/80 text-xs md:text-sm mt-1.5 line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 text-primary-300 text-sm font-medium mt-3">
                共 {getContentsByType(cat.type).length} 条内容
                <i className="ri-arrow-right-line" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}